import type { ComponentProps } from 'react'
import { cn } from '../lib/cn'
export function InputGroup({ className, ...props }: ComponentProps<'div'>) {
  return (
    <div
      {...props}
      data-slot="input-group"
      className={cn(
        'relative flex min-w-0 items-center [&:has([data-side=start])>input]:pl-11 [&:has([data-side=end])>input]:pr-14',
        className,
      )}
    />
  )
}
export function InputAddon({
  side = 'start',
  className,
  ...props
}: ComponentProps<'div'> & { side?: 'start' | 'end' }) {
  return (
    <div
      {...props}
      data-slot="input-addon"
      data-side={side}
      className={cn(
        'absolute flex items-center text-xs text-muted-foreground [&>svg]:size-4',
        side === 'start' ? 'left-3.5' : 'right-3.5',
        className,
      )}
    />
  )
}
